import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import AddForm from "./addForm";
import {
  useGetColorsQuery,
  useAddColorsMutation,
  useUpdateColorsMutation,
  useDeleteColorsMutation,
} from "slices/eCommerce/colorSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";

function Colors() {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [add] = useAddColorsMutation();
  const [update] = useUpdateColorsMutation();
  const [del] = useDeleteColorsMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, refetch } = useGetColorsQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Name", key: "name", type: "display" },
    {
      display: "Sub-Category",
      key: "cat",
      type: "display", // optional if you want to distinguish types
      render: (row) => <>{row.subcategory?.name || "-"}</>,
    },
    {
      display: "Color Code",
      key: "code",
      type: "display",
    },
  ];

  const canEdit = hasActionAccess(auth, "E-Commerce", "Colors", "edit");
  const canDelete = hasActionAccess(auth, "E-Commerce", "Colors", "delete");

  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };
  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    setEditing(row);
    setOpen(true);
  };

  const handleAdd = () => {
    setEditing(null);
    setOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this color?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const handleSubmit = async (data) => {
    try {
      if (editing) {
        await update({ id: editing._id, body: data }).unwrap();
        refetch();
      } else {
        await add(data).unwrap();
        refetch();
      }

      setOpen(false);
    } catch (e) {
      console.log("e===========>", e);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null); // <-- Clear editing data
  };

  const canAdd = hasActionAccess(auth, "E-Commerce", "Colors", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <AddForm
        open={open}
        onClose={handleClose}
        initialData={editing}
        onSubmit={handleSubmit}
      />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Color
        </Button>
      )}

      <Tables
        title={"Colors"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Colors;
